import React, { useEffect } from 'react';

import ApiTokenForm from './ApiTokenForm';
import DomainForm from './DomainForm';

interface IProps {
  domain: string;
  hasDomain: boolean;
  validated: boolean;
  tokenApi: string;
  loading: boolean;
  handleDomain: (domain: string) => void;
  handleReload: () => void;
  handleTokenApi: (tokenApi: string) => void;
}

function FacebookForm({ loading, hasDomain, handleReload, validated, domain, handleDomain, handleTokenApi, tokenApi }: IProps) {
  useEffect(() => handleReload(), [handleReload]);

  return (
    <>
      <div className='m16' />
      <ApiTokenForm loading={loading} tokenApi={tokenApi} handleTokenApi={handleTokenApi} />
      <div className='m16' />
      <DomainForm handleDomain={handleDomain} validated={validated} hasDomain={hasDomain} domain={domain} loading={loading} />
    </>
  );
}

export default React.memo(FacebookForm);
